// @module VintenCloud.Downloads.Downloads
define('VintenCloud.Downloads.Downloads.View', [

    'vintencloud_downloads_downloads.tpl',
    'VintenCloud.Downloads.SS2Collection',
    
    'ListHeader.View',
    'Backbone',
    "Utils"

], function (

    vintencloud_downloads_downloads_tpl,
    DownloadsSS2Collection,
    OrderHistoryListView,
    
    Backbone,
    Utils

) {
    'use strict';

    // @class VintenCloud.Downloads.Downloads.View @extends Backbone.View
    return Backbone.View.extend({

        template: vintencloud_downloads_downloads_tpl,

        initialize: function (options) {

            var self = this;

            this.collection = new DownloadsSS2Collection();

            this.keywords = Utils.getParameterByName(document.URL, 'keywords');
            this.page = Utils.getParameterByName(document.URL, 'page');

            this.listenCollection();

            this.collection.fetch({
                data: {
                    page: this.page,
                    keywords: this.keywords
                }
            }).done(function () {
                self.setLoading(false);
                self.render();
            })

        },

        events: {
            'keyup [data-action="search-type"]': 'filterCollection'
        },

        setLoading: function (value) {
            this.isLoading = value;
        },

        columns: [
            { label: 'Image', type: "image" },
            { label: 'Part #', type: "text" },
            { label: 'Title', type: "text" },
            { label: 'Action', type: "text" }
        ],

        sortOptions: [

        ],

        listenCollection: function () {
            this.setLoading(true);

            this.collection.on({
                request: jQuery.proxy(this, 'setLoading', true),
                reset: jQuery.proxy(this, 'setLoading', false)
            });

        },

        filterCollection: function (e) {

            if (e) {

                e.preventDefault();

                if (this.collectionFilterDelay)
                    clearTimeout(this.collectionFilterDelay);

                var self = this;
                this.keywords = jQuery(e.currentTarget).val() || '';

                this.collectionFilterDelay = setTimeout(function () {

                    if (self.keywords.length > 3 || self.keywords.length == 0) {
                        self.setLoading(true);
                        Backbone.history.navigate('download?keywords=' + self.keywords, { trigger: false });
                        self.collection.fetch({
                            data: {
                                keywords: self.keywords
                            }
                        }).done(function () {
                            self.setLoading(false);
                            self.render();
                        })

                    }

                }, 800);

            }

        },

        getSelectedMenu: function getSelectedMenu() {
            return 'downloadspage'
        },

        beforeShowContent: function beforeShowContent() {
            this.getBreadcrumbPages = function () {
                return [{
                    text: Utils.translate('Downloads'),
                    href: '/downloads'
                }]
            }
            this.title = Utils.translate('Downloads');
            return jQuery.Deferred().resolve()
        },

        childViews: _.extend({}, OrderHistoryListView.prototype.childViews),

        getContext: function () {

            // @class OrderHistory.List.View.Context
            return {
                // @property {String} pageHeader
                pageHeader: this.page_header,
                // @property {Boolean} collectionLengthGreaterThan0
                collectionLengthGreaterThan0: this.collection.length > 0,
                // @property {Boolean} isLoading
                isLoading: this.isLoading,
                // @property {Boolean} showPagination
                showPagination: !!(this.collection.totalRecordsFound && this.collection.recordsPerPage),
                // @property {Boolean} allIsActive
                allIsActive: this.activeTab === 'all',
                // @property {Boolean} openIsActive
                openIsActive: this.activeTab === 'open',
                // @property {Array<{}>} columns
                totalResults: this.collection.totalRecordsFound,

                assetsList: this.collection.models,

                keywords: this.keywords,

                columns: this.columns
            };
        }

    });
});
